module.exports = __webpack_public_path__ + "img/Frame-74.b3d404c3.svg";